import {
  DisplayProperties,
  TierType
} from '@com-delta-idp/mnx-skymiles-shared';
import { Image, Link } from '@com-delta-idp/mnx-ui-kit';

export interface Actions {
  next: string;
  previous: string;
}

export interface Goodie {
  name: string;
  icon: Image;
  link?: Link;
}

export interface Stack {
  title: string;
  ariaLabels: AriaLabels;
  tier: TierType;
  current: boolean;
  goodies: Goodie[];
}

export interface AriaLabels {
  banner: string;
  peekBar: string;
}

export interface Benefits extends DisplayProperties {
  title: string;
  stacks: Stack[];
  actions: Actions;
}

export type ActionType = 'next' | 'previous' | 'bar';
